export default __webpack_public_path__ + "static/media/Astra_artwork.6d93cf40.png";